export const LEASE_TYPE = {
  // 融租
  FINANCIAL: 1,
  // 经租
  ECONOMIC: 2,
}

// 租赁类型
export const LEASE_TYPE_OPTIONS = [{
  label: '融租',
  value: LEASE_TYPE.FINANCIAL,
}, {
  label: '经租',
  value: LEASE_TYPE.ECONOMIC,
}]

export const specialAssetsArr = [
  { key: 1, name: '首年交强险' },
  { key: 2, name: '首年商业险' },
  { key: 3, name: '基础保养' },
  { key: 4, name: '车辆上牌' },
  { key: 5, name: '车证办理' },
  { key: 6, name: 'GPS/TBOX' },
  { key: 7, name: '车膜' },
  { key: 8, name: '脚垫' },
]

export const columns1 = [
  {
    name: 'index',
    columnProps: {
      label: '方案序号',
      prop: 'index',
      width: '100px',
    },
  },
  {
    name: 'downPayment',
    columnProps: {
      label: '首付款（元）',
      prop: 'downPayment',
      width: '120px',
    },
  },
  {
    name: 'leasePeriods',
    columnProps: {
      label: '租赁期数',
      prop: 'leasePeriods',
      width: '100px',
    },
  },
  {
    name: 'rent',
    columnProps: {
      label: '月租金（元）',
      prop: 'rent',
      width: '120px',
    },
  },
  {
    name: 'margin',
    columnProps: {
      label: '保证金/押金（元）',
      prop: 'margin',
      width: '150px',
    },
  },
  {
    name: 'commission',
    columnProps: {
      label: '手续费（元）',
      prop: 'commission',
      width: '120px',
    },
  },
  {
    name: 'yearRate',
    columnProps: {
      label: '年利率',
      prop: 'yearRate',
      width: '120px',
    },
    getText: ({ row }) => (row.yearRate ? `${row.yearRate}%` : '--'),
  },
]

export const columns2 = [
  {
    name: 'index',
    columnProps: {
      label: '方案序号',
      prop: 'index',
      width: '100px',
    },
  },
  {
    name: 'leasePeriods',
    columnProps: {
      label: '租赁期数',
      prop: 'leasePeriods',
      width: '100px',
    },
  },
  {
    name: 'rent',
    columnProps: {
      label: '月租金（元）',
      prop: 'rent',
      width: '120px',
    },
  },
  {
    name: 'margin',
    columnProps: {
      label: '保证金/押金（元）',
      prop: 'margin',
      width: '150px',
    },
  },
]

const COLUMN_BOX_LIST_1 = [
  {
    key: 'title',
    name: '信息标题',
  },
  {
    key: 'brandName',
    name: '品牌',
  },
  {
    key: 'seriesName',
    name: '车系',
  },
  {
    key: 'modelName',
    name: '车型',
  },
  {
    key: 'leaseTypeName',
    name: '方案类型',
  },
  {
    key: 'transactionCityName',
    name: '交车城市',
  },
]

const COLUMN_BOX_LIST_2 = [
  {
    key: 'financialInstitutionName',
    name: '金融机构',
  },
  {
    key: 'leaseModelName',
    name: '租赁模式',
  },
  {
    key: 'repaymentMethodName',
    name: '还款方式',
  },
  {
    key: 'unitPrice',
    name: '车辆单价',
  },
]

const COLUMN_BOX_LIST_3 = [
  {
    key: 'inventory',
    name: '库存量',
  },
  {
    key: 'releaseCompany',
    name: '信息发布公司',
  },
  {
    key: 'releaseDate',
    name: '发布时间',
  },
  {
    key: 'leaseProgrammes',
    name: '租赁方案',
    alone: true,
  },
  {
    key: 'additionalServices',
    name: '附加服务',
    alone: true,
  },
  {
    key: 'detailDesc',
    name: '方案描述',
    alone: true,
  },
  {
    key: 'picture',
    name: '车辆图片',
    alone: true,
  },
]

export const COLUMN_BOX_LIST = [
  ...COLUMN_BOX_LIST_1,
  ...COLUMN_BOX_LIST_2,
  ...COLUMN_BOX_LIST_3,
]

export const COLUMN_BOX_LIST_LESS = [
  ...COLUMN_BOX_LIST_1,
  ...COLUMN_BOX_LIST_3,
]
